import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";

export interface MatterSettingStaticOption {
  displayOrder: number;
  label: string;
  value: string;
}

export interface MatterSettingStatics {
  taskPlanActions: MatterSettingStaticOption[];
}

export async function retrieveMatterSettingStaticsV2() {
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<MatterSettingStatics>
  >("matters/v2/setting-statics");
  return response.data;
}
